import { useRouter } from 'next/router'
import { useState, useEffect } from 'react'
import { useStoreState, useStoreActions } from 'easy-peasy'

export default function Container ({ children }) {
  const router = useRouter()
  const [isLoading, setIsLoading] = useState(false)

  const state = useStoreState(s => ({
    orders: s.orders
  }))

  const actions = useStoreActions(a => ({
    getOrders: a.getOrders
  }))

  const [ordersCount, setOrdersCount] = useState(0)
  const [orders, setOrders] = useState([])

  useEffect(() => {
    actions.getOrders({ status: 'processing' })
  }, [])

  useEffect(() => {
    const { status, payload } = state.orders
    if (status === 2) {
      setOrdersCount(payload.count)
      setOrders(payload.results)
    }
  }, [state.orders])

  const redirectLink = (url) => {
    setIsLoading(true)
    router.push(url)
  }

  return children({
    state,
    ordersCount,
    orders,
    isLoading,
    setIsLoading,
    redirectLink
  })
}
